import request from '@/utils/request_2'
/**
 * 药康夫api_1.0.8接口
 */
// 获取指定会员与健康管理者关系
export function getRelationByMemberId(params) {
    return request({
        url: '/system/memberHealthManagerRelation/getRelationByMemberId',
        method: 'get',
        params
    })
}
// 获取会员详情接口
export function getMemberDetail(data) {
    return request({
        url: '/system/memberArchives/getArchivesInfoByMemberId',
        method: 'get',
        params: data
    })
}
// 查询会员标签集
export function getMemberTag(data) {
    return request({
        url: 'system/memberLabel/list',
        params: data,
        method: 'get'
    })
}
// 档案信息审核
export function archivesInfoAudit(data) {
    return request({
        url: '/system/memberArchives/archivesInfoAudit',
        params: data,
        method: 'get'
    })
}
// 删除家庭成员
export function deleteFamily(data) {
    return request({
        url: 'system/memberFamily/deleteById',
        params: data,
        method: 'get'
    })
}
// 修改会员信息接口
export function updateMemberInfo(data) {
    return request({
        url: '/system/member/saveOrUpdate',
        data: data,
        method: 'post'
    })
}
// 查询门店列表
export function listStore(query) {
    return request({
        url: '/system/store/list',
        method: 'get',
        params: query
    })
}
// 工单列表接口
export function getWorkOrder(data) {
    return request({
        url: '/system/workOrder/list',
        method: 'post',
        data: data
    })
}
// 工单处理完成
export function completeWork(data) {
    return request({
        url: '/system/workOrder/followUp',
        params: data,
        method: 'get'
    })
}
// 查询健康管理师/医师/运营师列表
export function getRoleList(data) {
    return request({
        url: '/system/user/queryUserListByRoleId',
        params: data,
        method: 'get'
    })
}
// 工单转移
export function orderMove(data) {
    return request({
        url: '/system/workOrder/transfer',
        params: data,
        method: 'get'
    })
}
// 会员转移
export function memberMove(data) {
    return request({
        url: '/system/member/transfer',
        params: data,
        method: 'get'
    })
}
// 门店转移
export function storeMove(data) {
    return request({
        url: '/system/store/storeTransfer',
        params: data,
        method: 'get'
    })
}
// 判断该用户是否可删除或停用
export function isUserStatus(data) {
    return request({
        url: '/system/user/queryRelationDataByUserId',
        params: data,
        method: 'get'
    })
}
//查询健康管理师下的所有门店
export function getUserStore(data) {
    return request({
        url: '/system/store/queryStoreByHealthManager',
        params: data,
        method: 'get'
    })
}
// 服务申请列表
export function getServerList(data) {
    return request({
        url: '/system/memberServiceApplication/getMemberServiceApplicationList',
        params: data,
        method: 'get'
    })
}
// 服务申请处理
export function dealServerReport(data) {
    return request({
        url: '/system/memberServiceApplication/createHealthySchedule',
        data: data,
        method: 'post'
    })
}
// 创建服务报告
export function createServerReport(data) {
    return request({
        url: '/system/memberServiceApplication/insertHealthySchedule',
        data: data,
        method: 'post'
    })
}
// 根据id查服务详情
export function serverReportDetail(data) {
    return request({
        url: '/system/memberServiceApplication/getApplicationById',
        params: data,
        method: 'get'
    })
}
// 系统报告
export function systemReportList(data) {
    return request({
        url: '/system/memberWeekReport/list',
        method: 'get',
        params: data
    })
}
// 新增跟进记录
export function addFollowRecord(data) {
    return request({
        url: '/system/memberOperatingRecord/insertOperatingRecord',
        data: data,
        method: 'post'
    })
}

/**
 * 药康夫1.0.9接口
 */

//  会员积分明细
export function getMemberIntegral(url, data) {
    return request({
        url: url,
        data: data,
        method: 'post'
    })
}
// 会员账户金额明细
export function getMemberAccountDetail(url, data) {
    return request({
        url: url,
        data: data,
        method: 'post'
    })
}
// 会员总积分
export function memberTotalIntegral(data) {
    return request({
        url: '/system/memberIntegral/getIntegralInfo',
        params: data,
        method: 'get'
    })
}
// 查询会员可用余额以及累计提现金额
export function getMemberTotalMoney(data) {
    return request({
        url: '/system/memberAccountInfo/getMemberUsableAmountAndAllWithdrawDeposit',
        params: data,
        method: 'get'
    })
}
// 活动订单列表
export function activityOrderList(data) {
    return request({
        url: '/system/activityOrder/list',
        data: data,
        method: 'post'
    })
}
// 根据活动订单号获取活动订单商品明细列表
export function activityShoppingList(data) {
    return request({
        url: '/system/activityOrder/getActivityOrderByOrderNum',
        params: data,
        method: 'get'
    })
}
// 填写保存活动订单物流信息
export function saveLogisticsInfo(data) {
    return request({
        url: '/system/activityOrder/saveActivityOrderLogisticsInfo',
        params: data,
        method: 'get'
    })
}
// 修改活动订单状态为：已完成
export function updateOrderStatus(data) {
    return request({
        url: 'system/activityOrder/updateActivityOrderStatus',
        params: data,
        method: 'get'
    })
}
// 提现记录
export function withdrawalList(data) {
    return request({
        url: 'system/memberWithdrawDeposit/list',
        data: data,
        method: 'post'
    })
}
// 活动订单退款
export function activityOrderRefund(data) {
    return request({
        url: 'system/activityOrder/activityOrderRefund',
        params: data,
        method: 'get'
    })
}

export function getRefundAmountAndReturnCashAmount(data) {
    return request({
        url: 'system/activityOrder/getRefundAmountAndReturnCashAmount',
        params: data,
        method: 'get'
    })
}
export function getOrderRefundRecord(data) {
    return request({
        url: 'system/orderRefunds/getOrderRefundRecord',
        params: data,
        method: 'get'
    })
}

// 查询会员标签集
export function queryUserIsHaveHighestRole(data) {
    return request({
        url: 'system/user/queryUserIsHaveHighestRole',
        params: data,
        method: 'get'
    })
}
/**
 * 药康夫1.1.1接口API
 */
// 获取慢病案例列表
export function getDiseaseExample(data) {
    return request({
        url: 'system/chronicDiseaseExample/list',
        data,
        method: 'post'
    })
}
// 修改慢病案例
export function saveOrUpdate(data) {
    return request({
        url: 'system/chronicDiseaseExample/saveOrUpdate',
        data: data,
        method: 'post'
    })
}
// 删除慢病案例
export function delDiseaseExample(data) {
    return request({
        url: 'system/chronicDiseaseExample/deleteById',
        params: data,
        method: 'get'
    })
}
// 慢病案例信息启用状态更新，状态（1：启动，2：未启用）
export function statusUpdate(data) {
    return request({
        url: 'system/chronicDiseaseExample/statusUpdate',
        params: data,
        method: 'get'
    })
}
// 慢病专家列表
export function expertsList(data) {
    return request({
        url: 'system/chronicDiseaseExpert/list',
        data,
        method: 'post'
    })
}
// 慢病专家信息启用状态更新，状态（1：启动，2：未启用）
export function expertsStatusUpdate(data) {
    return request({
        url: 'system/chronicDiseaseExpert/statusUpdate',
        params: data,
        method: 'get'
    })
}
// 新增/更新慢病专家信息
export function saveOrUpdateExpert(data) {
    return request({
        url: 'system/chronicDiseaseExpert/saveOrUpdate',
        data: data,
        method: 'post'
    })
}
//慢病专家信息删除
export function delExpert(data) {
    return request({
        url: 'system/chronicDiseaseExpert/deleteById',
        params: data,
        method: 'get'
    })
}
// 获取设备配置列表
export function getHardwareConfigList(data) {
    return request({
        url: 'system/hardwareConfig/getHardwareConfigList',
        params: data,
        method: 'get'
    })
}
// 新增/更新检测设备
export function saveOrUpdateHardware(data) {
    return request({
        url: 'system/hardwareConfig/saveOrUpdateHardware',
        data: data,
        method: 'post'
    })
}
// 设备启用状态更新，状态（1：启动，2：未启用）
export function hardwareSaveOrUpdate(data) {
    return request({
        url: 'system/hardwareConfig/statusUpdate',
        params: data,
        method: 'get'
    })
}

// 免登
export function subsysAuth(data) {
    return request({
        url: 'auth/subSysLoginAuth',
        params: data,
        method: 'get'
    })
}
/**
 * 药康夫1.1.2接口API
 */
// 根据门店查设备
export function getEquipmentById(data) {
    return request({
        url: 'system/hardwareConfig/list',
        params: data,
        method: 'get'
    })
}
// 查询所有设备
export function getEquipment(data) {
    return request({
        url: "/system/hardwareConfig/snConfigListBindStatus",
        // url: '/system/hardwareConfig/snConfigListStatus',
        params: data,
        method: 'get'
    })
}
//获取设备信息
export function getEquipmentData(data) {
    return request({
        url: '/system/hardwareConfig/getHardwareConfigList',
        params: data,
        method: 'get'
    })
}
// 新增设备
export function addEquipment(data) {
    return request({
        url: '/system/hardwareConfig/updeteOrInsertSnConfigAndEnterpriseAndStoreId',
        data: data,
        method: 'post'
    })
}
// 删除设备
export function deleteEquipment(data) {
    return request({
        url: '/system/hardwareConfig/deleteBySnId/',
        params: data,
        method: 'get'
    })
}